export default {
	props: {
		iframe: {
			default: false,
			type: Boolean
		},
		customNamespace: {
			default: null,
			type: String
		}
	},
	data() {
		const namespace = this.customNamespace ? this.customNamespace : this.iframe ? 'CognitoIframe' : 'Cognito';
		return {
			cognitoReady: new Promise(resolve => {
				if (this.$amp || this.$isServer) {
					resolve();
					return;
				}

				const scriptPath = this.iframe ? 'f/iframe.js' : 'f/seamless.js';
				const id = this.iframe ? 'cog-embed-iframe-script' : 'cog-embed-script';

				if (!document.getElementById(id)) {
					const embedScript = document.createElement('script');
					embedScript.setAttribute('id', id);
					embedScript.setAttribute('src', 'https://www.cognitoforms.com/' + scriptPath);
					if (this.iframe || this.customNamespace)
						embedScript.setAttribute('data-namespace', namespace);
					document.head.appendChild(embedScript);
				}

				const loaded = !!window[namespace];
				if (loaded) {
					resolve();
					this.$emit('cognito-ready');
				}
				else {
					document.getElementById(id).addEventListener('load', () => {
						resolve();
						this.$emit('cognito-ready');
					});
				}
			}),
			namespace: namespace
		};
	}
};